import { render, staticRenderFns } from "./arcturus.vue?vue&type=template&id=0fc56ffc&scoped=true&"
import script from "./arcturus.vue?vue&type=script&lang=js&"
export * from "./arcturus.vue?vue&type=script&lang=js&"
import style0 from "./arcturus.vue?vue&type=style&index=0&id=0fc56ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc56ffc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType4: require('D:/Project/kpwebsite/PC/components/content/content-type-4.vue').default})
